import React from "react";
import {useRequiredStore} from "../../../../../utils/store";
import {RootStoreContext} from "../../../../../stores/root/root.store";

interface RenderImgProps {
    src?: string;
    alt?: string;
}

export const RenderImg: React.FC<RenderImgProps> = ({src, alt}) => {

    const {authStore: { generateUri }} = useRequiredStore(RootStoreContext);

    return <img
        alt={alt}
        src={generateUri(src || "")}
    />
}